<h2 mat-dialog-title>DETALLE DE PRODUCTOS</h2>
<mat-dialog-content class="mat-typography">
  <div class="contenedor-form" *ngIf="loadingData">
    <mat-spinner
      [diameter]="100"
      style="margin:0 auto; top:15px;"
    ></mat-spinner>
  </div>

  <div class="row" [hidden]="loadingData">
    <div class="col s12 m12 l12">
      <table
        [hidden]="!haveData"
        datatable
        [dtTrigger]="dtTrigger"
        class="display"
        style="width:100%; font-size: 10px;">
        <thead>
          <tr>
            <th>Orden</th>
            <th>Código Producto</th>
            <th>Descripción Producto</th>
            <th>Cantidad</th>
            <th>Total Bruto</th>
            <th>Total Neto</th>
            <th>Kilos</th>
            <th>Arrobas</th>
            <th>Bultos</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of detallePedido; let i = index">
            <td style="text-align: center;">{{ i + 1 }}</td>
            <td>{{ item.IdExProducto }}</td>
            <td [matTooltip]="item.DescripcionProducto" matTooltipPosition="left">{{ item.DescripcionProducto | slice:0:20 }}</td>
            <td>{{ item.Cantidad }}</td>
            <td>{{ item.TotalBruto | currency: "$":"symbol":"1.0-0" }}</td>
            <td>{{ item.TotalNeto | currency: "$":"symbol":"1.0-0" }}</td>
            <td>{{ item.Kilos }}</td>
            <td>{{ item.Arrobas }}</td>
            <td>{{ item.Bultos }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="start">
  <button
    mat-raised-button
    color="primary"
    [mat-dialog-close]="dataModified"
    cdkFocusInitial
    style="float: left; margin-left: 90%;">
    Cerrar
  </button>
</mat-dialog-actions>

